module.exports = "/virtual-football-league/img/amblems/left/logos/AtleticoBilbao.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/AtleticoBilbao.png
// module id = 2051
// module chunks = 4